// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IPriorPlanDto
 */
export interface IPriorPlanDto {
    /**
     * 
     * @type {number}
     * @memberof IPriorPlanDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof IPriorPlanDto
     */
    name?: string;
}

/**
 * Check if a given object implements the IPriorPlanDto interface.
 */
export function instanceOfIPriorPlanDto(value: object): value is IPriorPlanDto {
    return true;
}

export function IPriorPlanDtoFromJSON(json: any): IPriorPlanDto {
    return IPriorPlanDtoFromJSONTyped(json, false);
}

export function IPriorPlanDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPriorPlanDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function IPriorPlanDtoToJSON(json: any): IPriorPlanDto {
    return IPriorPlanDtoToJSONTyped(json, false);
}

export function IPriorPlanDtoToJSONTyped(value?: IPriorPlanDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

